module.exports = __webpack_public_path__ + "static/media/maruchan.e6319f63.jpg";